module.exports = __webpack_public_path__ + "img/photoComingSoon.0ffc8afe.png";